export const GA_LABEL = 'datasettsok'
export const GA_CATEGORY = 'dh-datasettsok'

let isTrackingEnabled = false

export const initializeGa = trackingEnabled => {
  isTrackingEnabled = trackingEnabled
}

export const trackEvent = ({ action, label }) => {
  if (window.ga && isTrackingEnabled) {
    return window.ga('send', 'event', GA_CATEGORY, action, label)
  } else {
    if (typeof console !== 'undefined') {
      console.log(GA_CATEGORY, action, label)
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/analytics/index.js